export default __webpack_public_path__ + "static/media/closed.4b176a0a.png";